import {cn} from '@utilities/helpers'
import {HTMLAttributes} from 'react'

function ProgressBar({value, className, ...rest}: {value: number} & HTMLAttributes<HTMLDivElement>) {
    return (
        <div className={cn('flex items-center gap-1.5', className)} data-slot="progress-bar" {...rest}>
            <div className="h-2 grow rounded bg-neutral-300">
                <div className="h-2 rounded bg-primary-600" style={{width: `${value}%`}} />
            </div>
            <span className="w-[34px] text-right text-sm font-medium">{value}%</span>
        </div>
    )
}
export {ProgressBar}
